

define(['angular', 'squid/index', 'text!./template.html', 'xo-page-components/src/aside-header/directive', 'xo-wallet-components/src/installment-options/directive', 'xo-tray-height/dist/directive'], function (angular, squid, template) {
  return angular.module('hermes.page.xo-sidebar-installment-options.directive', ['squid', 'xo-aside-header.directive', 'xo-installment-options.directive', 'xo-tray-height.directive']).directive('xoSidebarInstallmentOptionsPage', function () {
    return {
      template: template,
      scope: {
        backUri: '=?',
        parentModel: '=?'
      },
      controller: function controller($scope, $rootScope, $state) {
        $scope.token = $rootScope.token;
        $scope.cardInfo = {
          number: $scope.parentModel.onboard.card.number.replace(/ /g, ''),
          type: $scope.parentModel.onboard.card.type
        };
        $scope.onComplete = function (result) {
          $scope.parentModel.setProperties({
            selectedInstallmentData: result
          });
          angular.element('#paymentMethod').removeClass('ng-invalid'); // FIXME : setup a callback in xo-multistep-signup

          $state.go($scope.backUri);
        };
        $scope.$emit('populated');
      }
    };
  });
});


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar-installment-options/directive.js
// module id = ./pages/xo-sidebar-installment-options/directive.js
// module chunks = 0